import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  ref: "scrollContainer",
  class: "scroll-container"
}
const _hoisted_2 = {
  key: 0,
  class: "load-more-container"
}
const _hoisted_3 = {
  key: 1,
  class: "no-listings"
}

import {reactive, watch, ref, onMounted} from "vue";
import { MarketListItem } from "@/models/frontend/MarketModels";
import { searchListings } from "@/services/backend/ListingService";
import { transformListingToMarketListItem } from "@/transformers/ListingTransformer";
import MarketListItemComponent from "@/components/screens/Market/MarketListItemComponent.vue";
 import { Filter } from "@/models/frontend/FeatureModels";
import { transformFiltersToSearchCriteria } from "@/transformers/FiltersTransformer";
import LoadingComponent from "@/components/common/LoadingComponent/LoadingComponent.vue";
import { UserService } from "@/services/backend/UserService";
import * as Session from "supertokens-web-js/recipe/session";

const limit = 100;

export default /*@__PURE__*/_defineComponent({
  __name: 'MarketListComponent',
  props: {
    filters: {},
    applyFiltersEvent: {}
  },
  setup(__props: any) {

const props = __props;

let listItems = reactive<MarketListItem[]>([]);
const isLoading = ref(false);
const hasMoreItems = ref(false);
const offset = ref(0);
const userID = ref<string>();

const loadListings = async (reset = false) => {
  if (isLoading.value || (!hasMoreItems.value && !reset)) return;
  isLoading.value = true;

  if (reset) {
    listItems = [];
    offset.value = 0;
    hasMoreItems.value = true;
  }

  const searchCriteria = transformFiltersToSearchCriteria(props.filters);
  searchCriteria.pagination = { limit: limit.toString(), offset: offset.value.toString() };

  const response = await searchListings(searchCriteria);
  listItems.push(...response.results.map(transformListingToMarketListItem));
  offset.value += limit;
  hasMoreItems.value = response.results.length === limit;
  isLoading.value = false;
};

onMounted(async()=>{
  const isLoggedIn = await Session.doesSessionExist();
  if(isLoggedIn){
    const response = await UserService.getUserId();
    userID.value = response;
  }

});

// Reload listings when filters change
watch(
    () => props.applyFiltersEvent,
    () => {
      loadListings(true);
    }
);


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listItems), (listItem) => {
      return (_openBlock(), _createBlock(MarketListItemComponent, {
        class: "market-item",
        key: listItem.id,
        item: listItem,
        userId: userID.value
      }, null, 8, ["item", "userId"]))
    }), 128)),
    _createVNode(LoadingComponent, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    (hasMoreItems.value && !isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (loadListings(false))),
            class: "btn-secondary-m btn-outline_black load-more"
          }, "Cargar más")
        ]))
      : _createCommentVNode("", true),
    (_unref(listItems).length==0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "empty-results" }, "Vaya, parece que no hay anuncios para esta búsqueda.", -1)),
          _createVNode(_component_router_link, {
            to: { name: 'create' },
            class: "btn-primary-m btn-primary-green",
            alt: "¡Crea tu propio anuncio!"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("¡Crea tu propio anuncio!")
            ])),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})